import classNames from 'classnames';
import he from 'he';
import React from 'react';
import {
  bindActionCreators
} from 'redux';
import {
  connect
} from 'react-redux';
import {
  compose
} from 'recompose';
import {
  push
} from 'react-router-redux';
import {
  Button,
  Col,
  Row
} from 'react-bootstrap';
import {
  LinkContainer
} from 'react-router-bootstrap';
import {
  ProgressChart
} from '../../../../partials';
import {
  routes,
} from '../../../../../constants';
import { Icon } from '../../../../components'
import { pluralise } from '../../../../../utils';

const TeamRow = ({
  teamStats,
  goTo
}) => (
    <div className={classNames('teamListing')}>
      <h2 className='hide-md'>
        {he.decode(teamStats.team.name)}
      </h2>
      <Row
        className='sm-gutter team-infoRow'
        onClick={(e) => goTo(routes.app.teams.teamMembers(teamStats.team.id))}>
        <Col xs={3} sm={3} md={1}>
          <div className='chart'>
            <ProgressChart progressPercentage={teamStats.stats.totalProgressPercentage} width={200} height={200} />
          </div>
        </Col>
        <Col xs={6} sm={6} md={3}>
          <h2 className='hide-sm'>
            {he.decode(teamStats.team.name)}
          </h2>
          <p>
            <strong>
              <small>
                {teamStats.stats.teamSize} {pluralise('member', teamStats.stats.teamSize)}
              </small>
            </strong>
          </p>
        </Col>
        <Col sm={3} xs={3} md={2} mdOffset={6}>
          <LinkContainer className='large' to={routes.app.teams.teamMembers(teamStats.team.id)}>
            <Button bsStyle='plain' className='large'>See team <Icon icon='chevron-right-large' /></Button>
          </LinkContainer>
        </Col>
      </Row>
    </div >
  );

const mapDispatchToProps = (dispatch) => ({
  goTo: bindActionCreators(push, dispatch),
});

export default compose(
  connect(undefined, mapDispatchToProps)
)(TeamRow);



// WEBPACK FOOTER //
// ./src/containers/pages/app/teams/partials/team-row.js